import { useEffect, useState } from "react";
import {
  Container,
  Grid,
  Box,
  Typography,
  Stack,
  Divider,
  FormControl,
  TextField,
  SvgIcon,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useForm, FormProvider, SubmitHandler } from "react-hook-form";
import { object, string, TypeOf } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "react-toastify";
import {
  LoginSocialGoogle,
  LoginSocialFacebook,
  LoginSocialTwitter,
  LoginSocialGithub,
  LoginSocialLinkedin,
  IResolveParams,
} from "reactjs-social-login";
import { useGeneratedbusinessurlblogsMutation } from "../../redux/api/promptApi";
import { usePlanDetailsMutation } from "../../redux/api/productApi";
import { LoadingButton } from "@mui/lab";
import BackSignin from "../../assets/back_signin.png";
import Logo from '../../assets/logo.svg';

import { ReactComponent as GoogleIcon } from "../../assets/ico_google.svg";
import { ReactComponent as FacebookIcon } from "../../assets/ico_facebook.svg";
import { ReactComponent as TwitterIcon } from "../../assets/ico_twtter.svg";
import { ReactComponent as GithubIcon } from "../../assets/ico_github.svg";
import { ReactComponent as LinkedinIcon } from "../../assets/ico_linkedin.svg";
import img54 from '../../assets/newimg/logo.png';

import {
  useSigninUserMutation,
  useSocialAuthMutation,
} from "../../redux/api/authApi";
import { useAppDispatch } from "../../redux/store";
import { useSubscribeNewsMutation } from "../../redux/api/authApi";
import { setModule } from "../../redux/features/genieSlice";
import axios from "axios";
import { setCookie, getCookie, removeCookie } from '../../utils/storageUtils';
import OceshaLogo from '../../assets/ocesha_images/ocesha_logo.png';
import { useGoogleLogin } from "@react-oauth/google";


const newsSubscribeform = object({
  email: string()
    .min(1, "Email address is required")
    .email("Email address is invalid"),
  status: string(),
})

export type NewsSubscriptionForm = TypeOf<typeof newsSubscribeform>

const signinSchema = object({
  email: string()
    .min(1, "Email address is required")
    .email("Email address is invalid"),
  password: string()
    .min(1, "Password is required")
    .min(8, "Password must be more than 8 characters"),
});

export type SigninInput = TypeOf<typeof signinSchema>;



const SigninPage = () => {

  const location = useLocation();
  const { CreatingfromLanding } = location.state || {};
  const { UrlfromLanding } = location.state || {};


  const [signinUser, signinState] = useSigninUserMutation();
  const navigate = useNavigate();

  const [generatedBusinessUrlBlogsMutation] = useGeneratedbusinessurlblogsMutation();

  const dispatch = useAppDispatch();
  const [authSocial, socialState] = useSocialAuthMutation();
  const [inputEmail, setInputEmail] = useState('');

  //  Password visibility state
  const [showPassword, setShowPassword] = useState(false);
  const handleTogglePassword = () => setShowPassword((prev) => !prev);

  const REDIRECT_URI = window.location.href;
  const [generatedBlogDetail, setGeneratedBlogDetail] = useState<any>();

  const [planDetails, setPlanDetails] = useState<any>();
  const [getuserPlanDetails] = usePlanDetailsMutation();
  const { email: prefillEmail, name: prefillName, fromSocialLogin, provider } = location.state || {};
  const methods = useForm<SigninInput>({
    resolver: zodResolver(signinSchema),
  });


  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmitHandler: SubmitHandler<SigninInput> = (values) => {
    signinUser(values);
    setInputEmail(values.email);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await generatedBusinessUrlBlogsMutation({ userid: inputEmail, createddate: '', createddate_to: '' });
        if ('data' in response) {
          const { data } = response.data;
          setGeneratedBlogDetail(data);
          console.log('data from variable=>', generatedBlogDetail);
        } else if ('error' in response) {

          const { error } = response;
          console.log('Error:', error);
        }
      } catch (error) {
        console.error('Error fetching blogs:', error);
      }
    };

    fetchData();
  }, [generatedBusinessUrlBlogsMutation, inputEmail]);

  useEffect(() => {
    console.log(generatedBlogDetail);
    console.log(inputEmail);
  }, [generatedBlogDetail, inputEmail]);

  const fetchPlanDatas = async () => {
    try {
      const response = await getuserPlanDetails({ email: localStorage.getItem('user_email') || '', campaignid: '' });
      console.log('plan details from signin=>', response);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchPlanDatas();
  }, [])

  useEffect(() => {
    if (signinState.isSuccess) {
      toast.success("Login Success");
      const subscriptionLevel = signinState.data.subscription_level;
      const redirect = localStorage.getItem("redirectAfterLogin")
      const savedCourseId = localStorage.getItem("selected_course_id");

      localStorage.clear();

      console.log("signinState data", signinState.data);

      if (savedCourseId) {
        localStorage.setItem("selected_course_id", savedCourseId);
      }

      localStorage.setItem("logged_in", "true");
      localStorage.setItem("free_plan", signinState.data.free_plan.toString());

      localStorage.setItem(
        "remaining_wish_count",
        signinState.data.remaining_wish_count.toString()
      );

      localStorage.setItem("user_email", signinState.data.user_email || "");

      if (signinState?.data?.user_email) {
        setCookie("user_email", signinState.data.user_email);
      }

      localStorage.setItem("userRole", signinState.data.role);

      localStorage.setItem(
        "partner_name",
        signinState.data.partner || ""
      );

      localStorage.setItem(
        "partner_type",
        signinState.data.partner_type || ""
      );

      const userRole = signinState.data.role;

      localStorage.setItem("course_id", signinState.data.course_id || "");
      localStorage.setItem(
        "subscription_level",
        signinState.data.subscription_level || ""
      );
      localStorage.setItem("expired", signinState.data.expired.toString());
      localStorage.setItem("payment_status", signinState.data.payment_status || "");
      // Redirect to pricing if no subscription
      if (!hasValidSubscription(subscriptionLevel) && userRole === "user") {
        navigate("/pricing");
        return;
      }


      if (signinState.data.expired.toString() == "true") {
        localStorage.setItem('activeItem', 'upgrade');
        navigate("/codegenie/generated-blogs");
        return;
      }

      if (signinState.data.onboard?.toString() == "incomplete") {
        navigate("/codegenie/onboarding_page", { state: { FromSignUp: "true" } });
        return;
      }

      if (redirect === "creator_directory") {
        localStorage.removeItem("redirectAfterLogin");

        navigate("/codegenie/creator-directory");
        return;
      }

      if (
        /* userRole === "student" && */
        redirect === 'checkout' &&
        savedCourseId
      ) {

        navigate("/codegenie/individual-course", {
          state: {
            courseId: savedCourseId,
            autoCheckout: true
          }
        });

        localStorage.removeItem("redirectAfterLogin");

        return;
      }

      else if (userRole === "student" && savedCourseId) {
        navigate("/codegenie/individual-course", {
          state: { courseId: savedCourseId }
        });

        localStorage.removeItem("selected_course_id");
      }


      else if (userRole === "student") {
        localStorage.setItem("activeItem", "course")
        navigate("/codegenie/generated-blogs");
      }

      else if (userRole === "user") {
        localStorage.setItem("activeItem", "authority");
        navigate("/codegenie/generated-blogs");
      }

      else {
        navigate("/admin/dashboard");
      }
    }

    if (signinState.isError) {
      localStorage.setItem("logged_in", "false");

      const errorData = (signinState.error as any)?.data;

      if (errorData?.detail) {
        if (Array.isArray(errorData.detail)) {
          errorData.detail.forEach((el: any) => {
            toast.error(`${el.loc?.[1] || ""} ${el.msg}`);
          });
        } else {
          toast.error(errorData.detail);
        }
      } else {
        toast.error("Login failed. Please try again.");
      }
    }
  }, [signinState]);


  useEffect(() => {
    if (socialState.isSuccess) {
      const data = socialState.data;
      handleAuthSuccess(data);
    }

    if (socialState.isError) {
      const err: any = socialState.error;

      if (typeof err?.data === "string") {
        toast.error(err.data);
      }


      else if (err?.data?.detail) {
        if (Array.isArray(err.data.detail)) {
          err.data.detail.forEach((el: any) => {
            toast.error(`${el.loc?.[1] || ""} ${el.msg}`);
          });
        } else {
          toast.error(err.data.detail);
        }
      }


      else {
        toast.error("Server error. Please try again.");
      }

      console.error("SOCIAL ERROR:", err);
    }
  }, [socialState]);

  const hasValidSubscription = (subscriptionLevel: any) => {
    return (
      subscriptionLevel !== undefined &&
      subscriptionLevel !== null &&
      subscriptionLevel !== ""
    );
  };

  const handleAuthSuccess = (data: any) => {
    if (!data) return;

    const savedCourseId = localStorage.getItem("selected_course_id");
    const redirect = localStorage.getItem("redirectAfterLogin");

    localStorage.clear();

    console.log("handleAuthSuccess data", data);

    if (savedCourseId) {
      localStorage.setItem("selected_course_id", savedCourseId);
    }

    // ✅ session setup
    localStorage.setItem("logged_in", "true");

    localStorage.setItem(
      "free_plan",
      data.free_plan?.toString() || "0"
    );

    localStorage.setItem(
      "remaining_wish_count",
      data.remaining_wish_count?.toString() || "0"
    );

    //localStorage.setItem("FirstLogin", "True");

    localStorage.setItem(
      "subscription_level",
      data.subscription_level || ""
    );
 
    const email = data.user_email || data.email || "";

    localStorage.setItem("user_email", email);
    localStorage.setItem("expired", data.expired.toString());

    if (email) {
      setCookie("user_email", email);
    }

    // ✅ FIXED ROLE (MAIN ISSUE)
    const userRole = data.role;
    localStorage.setItem("userRole", userRole);

    localStorage.setItem("payment", "");

    localStorage.setItem(
        "partner_name",
        data.partner || ""
      );

      localStorage.setItem(
        "partner_type",
        data.partner_type || ""
      );

    const registeredStatus = data.registered_status;
    const subscriptionLevel = data.subscription_level;

    // redirect override
    if (redirect === "creator_directory") {
      localStorage.removeItem("redirectAfterLogin");
      navigate("/codegenie/creator-directory");
      return;
    }

    // ✅ NEW USER
    if (registeredStatus === "New") {
      if (userRole === "student" && savedCourseId) {
        navigate("/codegenie/individual-course", {
          state: { courseId: savedCourseId }
        });
        localStorage.removeItem("selected_course_id");
      } else {
        navigate("/pricing", {
          state: { FromSignUp: "true" }
        });
      }
      return;
    }

    // ✅ OLD USER
    if (registeredStatus === "Old") {
      toast.success("Social signin success");

      // OLD USER without subscription
      if (!hasValidSubscription(subscriptionLevel) && userRole === "user") {
        navigate("/pricing");
        return;
      }

      if (userRole === "user") {
        localStorage.setItem("activeItem", "authority");
        navigate("/codegenie/generated-blogs");
      }
      else if (userRole === "student") {
        localStorage.setItem("activeItem", "course");
        navigate("/codegenie/generated-blogs");
      }
      else {
        navigate("/admin/dashboard");
      }

      return;
    }
  };

  const [subscribeVal, setSubscribeVal] = useState<NewsSubscriptionForm>({ email: '', status: '' })
  const [newsSubsctiptionMutation, newsSubscriptionState] = useSubscribeNewsMutation();

  const methodsfoot = useForm<NewsSubscriptionForm>({
    resolver: zodResolver(newsSubscribeform),
  });
  const {
    register: RegisterFoot,
    handleSubmit: handleSubmitFoot,
    formState: { errors: Errors },
  } = methodsfoot;
  const onSubmitHandlerFoot: SubmitHandler<NewsSubscriptionForm> = (values) => {
    newsSubsctiptionMutation(values);
  };
  const handleSubscribeNews = () => {
    newsSubsctiptionMutation(subscribeVal)
      .unwrap()
      .then((response) => {
        console.log('news subscription=>', response);
        const status = response.status;

        console.log(status);
        if (status === 'success') {
          toast.success(response.message);
          setSubscribeVal({
            email: '',
            status: ''
          });
        }
      })
      .catch((error) => {
        toast.error(error?.data?.detail ?? 'Something went wrong!');
        console.error('Error sending query:', error);
      });
  };

  const googleLogin = useGoogleLogin({
    scope: "openid email profile",

    onSuccess: async (tokenResponse) => {
      try {
        const res = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          }
        );

        if (!res.ok) {
          throw new Error("Failed to fetch Google user");
        }

        const data = await res.json();

        authSocial({
          provider: "google",
          email: data.email || "",
          username: data.email?.split("@")[0] || "",
          name: data.name || "",
          first_name: data.given_name || "",
          last_name: data.family_name || "",
          id: data.sub,
          initial_product: "CodeGenie",
          role: data?.role || "",
        });
      } catch (err) {
        console.error(err);
        toast.error("Google login failed");
      }
    },

    onError: () => {
      toast.error("Google login failed");
    },
  });

  return (
    <>
      {/* Header */}
      <div className="container">
        <div className="row">
          <nav className="navbar navbar-expand-md">
            <div className="container-fluid">
              <a className="navbar-brand" href={process.env.REACT_APP_LOGOUT_DOMAIN || "https://ocesha.ai"} style={{ textAlign: 'left' }}>
                <img src={OceshaLogo} className="img-fluid" alt="" style={{ width: '5%' }} />
              </a>
            </div>
          </nav>
        </div>
      </div>
      {/*  */}
      <div className="row">
        <div className="col-md-6 text-white text-center mt-2">
          <div className="px-sm-0 px-2">
            <div>
              <div className="Ac-1">
                <div>
                  <Grid item xs={6} position="relative">
                    <img className="signinimg" src={BackSignin} alt="Signup Background" />
                    <Typography
                      position="absolute"
                      bottom={103}
                      left={0}
                      variant="h4"
                      width="100%"
                      fontWeight={600}
                      color="white"
                    >
                    </Typography>

                  </Grid>
                </div>
              </div> <br></br> <br></br>
            </div>
          </div>
        </div>
        <div className="col-md-6 my-auto">
          <div className="px-sm-0 px-2">
            <p className="Sign-1">
              <Box width={464}>
                <div className="Sign-2">
                  <Typography variant="h4" mb={4} color="text.secondary">
                    Sign in your account
                  </Typography>
                </div>
                <FormProvider {...methods}>
                  <Box
                    component="form"
                    noValidate
                    onSubmit={handleSubmit(onSubmitHandler)}
                  >
                    <Stack gap={3}>
                      <FormControl fullWidth>
                        <Typography mb={1} color="text.secondary">
                          Email address
                        </Typography>
                        <TextField
                          {...register("email")}
                          type="email"
                          placeholder="Enter your email"
                          error={!!errors["email"]}
                          helperText={errors["email"]?.message}
                          style={{ border: '1px solid #CBCBCB', borderRadius: '5px' }}
                        />
                      </FormControl>
                      <FormControl fullWidth>
                        <Stack
                          mb={1}
                          flexDirection="row"
                          justifyContent="space-between"
                        >
                          <Typography color="text.secondary">Password</Typography>
                          <Link
                            to="/forgot"
                            style={{
                              color: "#0168B5",
                              textDecoration: "none",
                            }}
                          >
                            Forgot Password?
                          </Link>
                        </Stack>
                        {/* Password field with custom show/hide toggle */}
                        <TextField
                          {...register("password")}
                          // Dynamically switch between "password" and "text"
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter your password"
                          error={!!errors["password"]}
                          helperText={errors["password"]?.message}
                          style={{ border: '1px solid #CBCBCB', borderRadius: '5px' }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={handleTogglePassword}
                                  edge="end"
                                  disableRipple
                                  sx={{
                                    color: "#ffffff",           // White icon to match dark theme
                                    backgroundColor: "transparent",
                                    "&:hover": {
                                      backgroundColor: "transparent",
                                      color: "#cccccc",          // Slightly dimmed on hover
                                    },
                                    //  This hides the browser's built-in eye icon (Edge/Chrome)
                                    "& input::-ms-reveal": { display: "none" },
                                    "& input::-ms-clear": { display: "none" },
                                  }}
                                  aria-label="toggle password visibility"
                                >
                                  {showPassword ? (
                                    <VisibilityOff sx={{ fontSize: 20, color: "#ffffff" }} />
                                  ) : (
                                    <Visibility sx={{ fontSize: 20, color: "#ffffff" }} />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                            //  Global CSS override to suppress browser's native eye icon
                            inputProps: {
                              style: { color: "inherit" },
                            },
                            sx: {
                              // Hide MS Edge/IE native password reveal button
                              "& input::-ms-reveal, & input::-ms-clear": {
                                display: "none",
                              },
                              // Hide Chrome/Safari native password reveal button
                              "& input::-webkit-credentials-auto-fill-button": {
                                visibility: "hidden",
                                display: "none !important",
                                pointerEvents: "none",
                                position: "absolute",
                                right: 0,
                              },
                            },
                          }}
                        />
                      </FormControl>
                    </Stack>
                    <LoadingButton
                      loading={signinState.isLoading}
                      type="submit"
                      fullWidth
                      sx={{
                        height: 56,
                        background:
                          "linear-gradient(90deg, #036AB7 0%, #4BA5EB 100%)",
                        color: "white",
                        mt: 4,
                      }}
                    >
                      Log in
                    </LoadingButton>
                  </Box>
                </FormProvider>
                <Stack
                  flexDirection="row"
                  alignItems="center"
                  gap={1}
                  height={44}
                  mt={3}
                >
                  <Divider sx={{ flexGrow: 1 }} />
                  <Typography>Or</Typography>
                  <Divider sx={{ flexGrow: 1 }} />
                </Stack>
                <Stack direction="column" alignItems="center" mt={2}>
                  {/* <Box
                    sx={{
                      border: "1px solid #CACBCC",
                      borderRadius: "50px",
                      padding: "10px 20px",
                      cursor: "pointer",
                      width: "240px",
                      backgroundColor: "transparent",
                    }}
                  > */}
                  {/* <LoginSocialGoogle
                      client_id={process.env.REACT_APP_GG_APP_ID || ""}
                      scope="email"
                      onResolve={({ provider, data }: IResolveParams) => {
                        if (data)
                          authSocial({
                            provider: provider as string,
                            email: data?.email || "",
                            username: data?.email?.split("@")[0] || "",
                            name: data?.name || "",
                            first_name: data?.first_name || "",
                            last_name: data?.last_name || "",
                            id: data.sub as string,
                            initial_product: "CodeGenie",
                            role: data?.role || "",
                          });

                      }}
                      onReject={(err) => {
                        console.log(err);
                      }}
                    > */}
                  <Box
                    onClick={() => googleLogin()}
                    sx={{
                      border: "1px solid #CACBCC",
                      borderRadius: "50px",
                      padding: "12px 20px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "240px",
                      /* "&:hover": {
                        backgroundColor: "#f5f5f5",
                      }, */
                    }}
                  >
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={1}
                      justifyContent="center"
                    >
                      <GoogleIcon style={{ width: 20, height: 20 }} />
                      <Typography variant="body2">
                        Sign in with Google
                      </Typography>
                    </Stack>
                  </Box>
                  {/* </LoginSocialGoogle> */}
                  {/* </Box> */}
                </Stack>

                <Typography mt={3} style={{ color: '#fff' }}>
                  New user?{" "}
                  <Link
                    to="/signup"
                    state={{ newAccntFromSignin: 'true' }}
                    style={{
                      color: "#0168B5",
                    }}
                  >
                    Create an account
                  </Link>
                </Typography>
              </Box>
            </p>
          </div>
        </div>
      </div>


    </>
  );
};

export default SigninPage;